var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.Fragment,[(_setup.hasAuthorization)?_vm._t("default"):_vm._e(),_vm._t("handler",null,{"hasAuthorization":_setup.hasAuthorization})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }